import styled from 'styled-components'

import { BreadcrumbsUnstyled } from 'Components/Breadcrumbs/unstyled'

export const Breadcrumbs = styled(BreadcrumbsUnstyled)`
  width: 100%;
  height: 24px;

  .breadcrumbs__section {
    &:after {
      content: '/';
      margin: 0 6px;
      color: ${props => props.theme.colors.regentGray};
      font-size: ${props => props.theme.fontSizes.breadcrumbs};
    }

    a {
      font-size: ${props => props.theme.fontSizes.breadcrumbs};
      line-height: 24px;
      color: ${props => props.theme.colors.regentGray};
    }

    a:hover {
      text-decoration: none;
    }

    .breadcrumbs__separator {
      display: none;
    }
  }

  .breadcrumbs__section:last-child {
    &:after {
      display: none;
    }

    a {
      pointer-events: none;
    }
  }

  .breadcrumbs__section:not(:last-child) {
    &:after {
      display: initial;
    }

    a {
      color: ${props => props.theme.colors.primary};
      pointer-events: auto;
    }
  }

  svg {
    width: ${props => props.icon.width};
    height: 100%;
    float: left;
    fill: ${props => props.theme.colors.primary};
    margin: 0 6px 0 0;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Breadcrumbs/index.js